import LANG from './en'

/**
 * Data metrics in the SEDA data set
 */
export const METRICS = [
  {
    id: 'avg',
    label: LANG['LABEL_AVG'],
    range: {
      'map_*_gap': [-6, 6],
      map_states: [-1.5, 0.5],
      // map_counties: [-3, 3],
      map_districts: [-4, 4],
      map_schools: [-5, 5]
    },
    // regions: ['states', 'counties', 'districts', 'schools']
    regions: ['states', 'districts', 'schools']
  },
  {
    id: 'grd',
    label: LANG['LABEL_GRD'],
    range: {
      'map_*_gap': [-0.4, 0.4],
      'map_states_*': [0.8, 1.2],
      'map_*_*': [0.5, 1.5]
    },
    // regions: ['states', 'counties', 'districts', 'schools']
    regions: ['states', 'districts', 'schools']
  },
  {
    id: 'coh',
    label: LANG['LABEL_COH'],
    range: {
      'map_states_*': [-0.05, 0.05],
      'map_districts_*': [-0.3, 0.3],
      'map_schools_*': [-0.5, 0.5],
      'map_*_*': [-0.2, 0.2]
    },
    // regions: ['states', 'counties', 'districts', 'schools']
    regions: ['states', 'districts', 'schools']
  },
  {
    id: 'imp',
    label: LANG['LABEL_IMP'],
    range: {
      'map_states_*': [-0.03, 0.01],
      'map_schools_*': [-0.2, 0.2],
      'map_districts_*': [-0.14, 0.14],
      'map_*_*': [-0.05, 0.05]
    },
    // regions: ['states', 'counties', 'districts', 'schools']
    regions: ['states', 'districts', 'schools']
  },
  {
    id: 'ses',
    label: LANG['LABEL_SES_NO_REGION'],
    map: false,
    scatterplot: true,
    range: {
      'map_*_*': [-3, 3]
    },
    // regions: ['states', 'counties', 'districts']
    regions: ['states', 'districts']
  },
  {
    id: 'seg',
    label: LANG['LABEL_SEG'],
    range: {
      '*_*_np': [0, 0.75],
      '*': [-0.25, 0.75]
    },
    // regions: ['states', 'counties', 'districts']
    regions: ['states', 'districts']
  },
  {
    id: 'min',
    label: LANG['LABEL_MIN'],
    range: {
      '*': [-0.1, 0.7]
    },
    // regions: ['states', 'counties', 'districts']
    regions: ['states', 'districts']
  },
  {
    id: 'frl',
    label: LANG['LABEL_FRL'],
    range: {
      '*': [0, 1]
    },
    regions: ['schools']
  }
]

export const KEY_METRIC_IDS = ['avg', 'grd', 'coh', 'imp']

export const DEFAULT_RANGES = {
  states: {
    avg: [-5, 5],
    grd: [0, 2],
    coh: [-0.5, 0.5],
    imp: [-0.009, 0.002],
    ses: [-2, 2],
    limit: 52
  },
  // counties: {
  //   avg: [-5, 5],
  //   grd: [0, 2],
  //   coh: [-0.5, 0.5],
  //   imp: [-0.1, 0.1],
  //   ses: [-3, 3],
  //   limit: 3500
  // },
  districts: {
    avg: [-5, 5],
    grd: [0.3107, 1.6593],
    coh: [-0.5, 0.5],
    imp: [-0.01, 0.01],
    ses: [-3, 3],
    limit: 15000
  },
  schools: {
    avg: [-5, 5],
    grd: [0, 2],
    coh: [-0.5, 0.5],
    imp: [-0.3, 0.3],
    frl: [0, 1],
    limit: 80000
  }
}
